"use memo"

import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import TaskModalDialog from 'pages/allTasks/TaskModal/TaskModalDialog'
import type { ExchangeTaskFamily } from './ExchangeTask.shared'
import { useExchangeTaskModal } from './useExchangeTaskModal'

interface ExchangeTaskModalProps {
  campaignId: string
  family: ExchangeTaskFamily
  isOpen: boolean
  onClose: () => void
  tasks: AutopilotTaskDto[]
  title: string
}

const ExchangeTaskModal = ({
  campaignId,
  family,
  isOpen,
  onClose,
  tasks,
  title,
}: ExchangeTaskModalProps) => {
  const { campaign, contentConfig } = useExchangeTaskModal({
    campaignId,
    family,
    isOpen,
    tasks,
  })

  if (!campaign) return null

  return (
    <TaskModalDialog
      title={title}
      tasks={tasks}
      open={isOpen}
      onClose={onClose}
      campaignId={campaignId}
      campaign={campaign}
      contentConfig={contentConfig}
    />
  )
}

export default ExchangeTaskModal
